/**
 * @generated SignedSource<<c93e540d636d0b392cdbbee73a0755ce>>
 * @relayHash 62bedc769e6bd9abd36363472bc29495
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 1b61f743a91e56bc00fd4727121e1381902c2c173f101c226049470d68a35783

import type { ConcreteRequest, Query } from 'relay-runtime';
export type analyticsPermissionCheckCreateProjectQuery$variables = {
  cloudId: string;
};
export type analyticsPermissionCheckCreateProjectQuery$data = {
  readonly jira: {
    readonly canCreateCompanyManagedProject: boolean | null | undefined;
    readonly canCreateProject: boolean | null | undefined;
    readonly canCreateTeamManagedProject: boolean | null | undefined;
  } | null | undefined;
};
export type analyticsPermissionCheckCreateProjectQuery = {
  response: analyticsPermissionCheckCreateProjectQuery$data;
  variables: analyticsPermissionCheckCreateProjectQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  }
],
v1 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v2 = [
  {
    "concreteType": "JiraQuery",
    "kind": "LinkedField",
    "name": "jira",
    "plural": false,
    "selections": [
      {
        "alias": "canCreateProject",
        "args": [
          (v1/*: any*/),
          {
            "kind": "Literal",
            "name": "type",
            "value": "CREATE_PROJECT"
          }
        ],
        "kind": "ScalarField",
        "name": "canPerform"
      },
      {
        "alias": "canCreateTeamManagedProject",
        "args": [
          (v1/*: any*/),
          {
            "kind": "Literal",
            "name": "type",
            "value": "CREATE_TEAM_MANAGED_PROJECT"
          }
        ],
        "kind": "ScalarField",
        "name": "canPerform"
      },
      {
        "alias": "canCreateCompanyManagedProject",
        "args": [
          (v1/*: any*/),
          {
            "kind": "Literal",
            "name": "type",
            "value": "CREATE_COMPANY_MANAGED_PROJECT"
          }
        ],
        "kind": "ScalarField",
        "name": "canPerform"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "analyticsPermissionCheckCreateProjectQuery",
    "selections": (v2/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "analyticsPermissionCheckCreateProjectQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "id": "1b61f743a91e56bc00fd4727121e1381902c2c173f101c226049470d68a35783",
    "metadata": {},
    "name": "analyticsPermissionCheckCreateProjectQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "5895b8dfd4b6785a379d210f5d735279";

export default node;
